// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","523":"1ffe7e97","524":"862c1650","573":"38cce509","638":"4e841cad","933":"0c221e8b"}[chunkId] + ".chunk.js";
};